import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../';
import { AnyIfEmpty } from 'react-redux';

interface FileMetadata {
  name: string;
  size: number;
  type: string;
  lastModified: number;
}

interface ITransmissionState {
  isLoading: boolean,
  isConversationOpen: boolean,
  loadingMessage: string,
  uploadedFile: FileMetadata | null,
  uploadedFileName: string,
  conversationId: string,
  conversationNo: number,
  testReport: string,
  results: any[],
  reportsResults: any,
  allStarReportResults: any,
  currentFailureReportTitle: any,
  currentFailureReportSubtitle: any,
  nlgParameterTransmissionResult: any,
  isNlgParameterTransmissionLoading: boolean,
  reportFilePath: string
}

const initialState = {
  isLoading: false,
  isConversationOpen: true,
  loadingMessage: "",
  uploadedFile: null,
  uploadedFileName: "",
  conversationId: "ABCD",
  conversationNo: 0,
  testReport: "AJB06504XX",
  results: [],
  reportsResults: [],
  allStarReportResults: [],
  currentFailureReportTitle: '',
  currentFailureReportSubtitle: '',
  nlgParameterTransmissionResult: null,
  isNlgParameterTransmissionLoading: false,
  reportFilePath: ''
} as ITransmissionState

const transmissionSlice = createSlice({
  name: 'transmission',
  initialState,
  reducers: {
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setIsConversationOpen(state, action: PayloadAction<boolean>) {
      state.isConversationOpen = action.payload
    },
    setLoadingMessage(state, action: PayloadAction<string>) {
      state.loadingMessage = action.payload
    },
    setUploadedFile(state, action: PayloadAction<FileMetadata | null>) {
      state.uploadedFile = action.payload
    },
    setUploadedFileName(state, action: PayloadAction<string>) {
      state.uploadedFileName = action.payload
    },
    setConversationId(state, action: PayloadAction<string>) {
      state.conversationId = action.payload
    },
    setConversationNo(state, action: PayloadAction<number>) {
      state.conversationNo = action.payload
    },
    incrementConversationNo(state) {
      state.conversationNo += 1
    },
    setTestReport(state, action: PayloadAction<string>) {
      state.testReport = action.payload
    },
    setResults(state, action: PayloadAction<any>) {
      state.results.push(action.payload)
    },
    setReportsResults(state, action: PayloadAction<any>) {
      state.reportsResults = action.payload
    },
    setAllStarReportResults(state, action: PayloadAction<any>) {
      state.allStarReportResults = action.payload
    },
    setCurrentFailureReportTitle(state, action: PayloadAction<any>) {
      state.currentFailureReportTitle = action.payload
    },
    setCurrentFailureReportSubtitle(state, action: PayloadAction<any>) {
      state.currentFailureReportSubtitle = action.payload
    },
    clearResults(state) {
      state.results = []
    },
    setNlgParameterTransmissionResult(state, action: PayloadAction<any>) {
      state.nlgParameterTransmissionResult = action.payload
    },
    setIsNlgParameterTransmissionLoading(state, action: PayloadAction<boolean>) {
      state.isNlgParameterTransmissionLoading = action.payload
    },
    setReportFilePath(state, action: PayloadAction<string>) {
      state.reportFilePath = action.payload
    }
  }
})

export default transmissionSlice.reducer
export const { 
  setIsLoading, 
  setIsConversationOpen,
  setLoadingMessage, 
  setUploadedFile, 
  setUploadedFileName,
  setConversationId, 
  setConversationNo, 
  incrementConversationNo,
  setTestReport, 
  setResults, 
  clearResults,
  setReportsResults,
  setAllStarReportResults,
  setCurrentFailureReportTitle,
  setCurrentFailureReportSubtitle,
  setNlgParameterTransmissionResult,
  setIsNlgParameterTransmissionLoading,
  setReportFilePath
} = transmissionSlice.actions

export const selectIsLoading = (state: RootState) => state.transmission.isLoading;
export const selectIsConversationOpen = (state: RootState) => state.transmission.isConversationOpen;
export const selectLoadingMessage = (state: RootState) => state.transmission.loadingMessage;
export const selectUploadedFile = (state: RootState) => state.transmission.uploadedFile;
export const selectUploadedFileName = (state: RootState) => state.transmission.uploadedFileName;
export const selectConversationId = (state: RootState) => state.transmission.conversationId;
export const selectConversationNo = (state: RootState) => state.transmission.conversationNo;
export const selectTestReport = (state: RootState) => state.transmission.testReport;
export const selectResults = (state: RootState) => state.transmission.results;
export const selectReportsResults = (state: RootState) => state.transmission.reportsResults;
export const selectAllStarReportResults = (state: RootState) => state.transmission.allStarReportResults;
export const selectCurrentFailureReportTitle = (state: RootState) => state.transmission.currentFailureReportTitle;
export const selectCurrentFailureReportSubtitle = (state: RootState) => state.transmission.currentFailureReportSubtitle;
export const selectNlgParameterTransmissionResult = (state: RootState) => state.transmission.nlgParameterTransmissionResult;
export const selectIsNlgParameterTransmissionLoading = (state: RootState) => state.transmission.isNlgParameterTransmissionLoading;
export const selectReportFilePath = (state: RootState) => state.transmission.reportFilePath;